import React, { useState } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export default function CreateWorkflowDialog({ children, onCreate }) {

    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        if (!name.trim()) {
            setError('A workflow name is required.');
            return;
        }
        const ok = await onCreate(name.trim());
        if (ok) {
            setName('');
            setError('');
            setOpen(false);
        } else {
            setError('Something went wrong creating the workflow.');
        }
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>{children}</DialogTrigger>
            <DialogContent className="sm:max-w-[460px]">
                <DialogHeader>
                    <DialogTitle>Create Workflow</DialogTitle>
                    <DialogDescription>
                        A new workflow starts as a draft. You can build its value tiers and approval steps
                        next, then publish when ready.
                    </DialogDescription>
                </DialogHeader>
                <div className="flex flex-col gap-2 py-2">
                    <Label htmlFor="workflow-name">Workflow Name</Label>
                    <Input
                        id="workflow-name"
                        value={name}
                        placeholder="e.g. Two-tier approval"
                        onChange={(e) => setName(e.target.value)}
                    />
                    {error && <p className="text-sm text-red-600 mb-0">{error}</p>}
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
                    <Button className="bg-yavrio-green" onClick={handleSubmit}>Create</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
